export const SECTIONS = [
  { id: 0, min: 1, max: 25 },
  { id: 1, min: 104, max: 138 },
  { id: 2, min: 203, max: 241 },
  { id: 3, min: 301, max: 341 },
  { id: 4, min: 403, max: 439 },
];

export function bucketBySection(tables) {
  const sections = { 0: [], 1: [], 2: [], 3: [], 4: [] };
  const dynamic = [];

  for (const table of tables) {
    if (table.section !== null && table.section !== undefined && sections[table.section]) {
      sections[table.section].push(table);
    } else {
      dynamic.push(table);
    }
  }

  return { sections, dynamic };
}
